// 门店管理
const Advertise = () => import(/* webpackChunkName: "storeManage" */ '../../pages/micro-store/advertise');

export default [
  {
		path: '/microStore/advertise',
		name: 'microStoreAdvertise',
		component: Advertise
	},
]